module.exports = __webpack_public_path__ + "media/images/clearview-logo-9b1b65dcdfb38e1bb7835145afd5005e.png";